// src/components/common/PostalCodeSelect.jsx
import React, { useCallback } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import debounce from "lodash.debounce";
import { Controller } from "react-hook-form";
import { searchPostcodes } from "../utils/postcodeService"; // ← new path

export default function PostalCodeSelect({ name, control, country }) {
  /* debounce so the API isn’t spammed while user types */
  const loadOptions = useCallback(
    debounce((input, cb) => {
      searchPostcodes(input, [country]).then((opts) => cb(opts));
    }, 300),
    [country]
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <AsyncCreatableSelect
          cacheOptions
          defaultOptions={false}
          loadOptions={loadOptions}
          classNamePrefix="rs"
          placeholder="Type postal code…"
          value={
            field.value ? { value: field.value, label: `${field.value}` } : null
          }
          onChange={(opt) => field.onChange(opt ? opt.value : "")}
          formatOptionLabel={(opt) =>
            opt.iso ? `${opt.value} (${opt.iso})` : opt.label
          }
        />
      )}
    />
  );
}
